export default "__VITE_ASSET__BamBKp3D__"